<template>
  <b-table 
    :fields="['Omschrijving'].concat(quarters.map(function(q) { 
      return { 
        ...q, 
        key: `quarters.${q.key}.kpi`, 
        path: `quarters.${q.key}`,
        tdClass: css,
      }
    }
    )).concat([{
      key:'gemiddelde.kpi',
      label:'Totaal',
      path: 'gemiddelde',
      tdClass: css,
      result: service,
      filter: (i) => true
    }])"
    :items="kpiService"
    caption-top
    bordered
    striped
    dark
    @row-clicked="(row) => showRowDetails(row)"
  >
    <template #table-caption>
      {{ unitCount }} units
    </template>

    <template #head()="data">
      {{ data.label.toUpperCase() }} ({{ (data.field.result || []).length }})
    </template>

    <template #head(Omschrijving)="data">
      {{ data.label.toUpperCase() }} 
    </template>

    <template #head(gemiddelde)="data">
      {{ service.length }} 
    </template>
    
    <template #cell()="row">
      {{ row.item.quarters[`kw${row.field.index}`][config.modus] }}
      <span v-if="config.modus == 'percentage'">%</span>
    </template>
    
    <template #cell(gemiddelde.kpi)="row">
      {{ row.item.gemiddelde[config.modus] }}
      <span v-if="config.modus == 'percentage'">%</span>
    </template>

    <template #cell(Omschrijving)="row">
      {{ row.item.label }}
      <b-badge 
        v-for="(ty) in row.item.filters.category" 
        :key="ty" 
        class="m-1" 
        variant="warning"
      >
        {{ ty }}
      </b-badge>
      <br>
      <small>{{ replace(config.toelichting[row.item.toelichting], kpiInstellingen[row.item.toelichting]) }} </small>
    </template>

    <template #row-details="row">
      <b-input-group prepend="Titel">
        <b-form-input v-model="row.item.label" />
        <b-checkbox-group 
          v-model="row.item.filters.types" 
          :options="types" 
          buttons 
          button-variant="dark"
        />
      </b-input-group>
      <div v-if="row.item.gemiddelde.units != undefined">
        <b-table 
          :items="Object.keys(row.item.gemiddelde.units).map((u) => { return { unit: u, score: row.item.gemiddelde.units[u] }})"
          :fields="['unit','score']"
          caption-top
          bordered
          striped
          small
          hover
        >
          <template #table-caption>
            {{ row.item.gemiddelde.aantal }} units
          </template>
          <template #cell(score)="data">
            {{ data.item.score }}
          </template>
        </b-table>
      </div>
    </template>
  </b-table>
</template>

<script>
import moment from 'moment';
let keys = {
    'reactietijd': 'r' ,
    'oplostijd': 'g',
    'stilstandtijd': 'm',
    'telling': 'c'
};

export default {
    name: 'KpiTabel',
    components: {},
    mixins: [],
    props: {
        status: {
            type: Object,
            default: () => null
        },
        config: {
            type: Object,
            default: () => null
        },
        units: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return  {
            bgs: ['bg-danger','bg-warning','bg-success'],
            types: [ 'MAINTENANCE', 'INCIDENT', 'REPAIR', 'ASSISTANCE INSPECTION', 'CHECK'],
            keys : keys,
            report:[ 
              { 
              label: 'Beschikbaarheid totaal',
              filters: {
                types: ['INCIDENT','REPAIR'],
                category: []
              },
              value: keys.stilstandtijd,
              _showDetails: false,
              toelichting: "beschikbaarheid",
              result: this.beschikbaarheid,
            },
            { 
              label: 'Beschikbaarheid totaal',
              filters: {
                types: ['INCIDENT','REPAIR'],
                category: ['TO']
              },
              value: keys.stilstandtijd,
              _showDetails: false,
              toelichting: "beschikbaarheid",
              result: this.beschikbaarheid,
            },
            { 
              label: 'Storingen totaal',
              toelichting: 'storingen',
              filters: {
                types: ['INCIDENT'],
                category: []
              },
              value: keys.telling,
              _showDetails: false,
              result: this.storingen
            },
            { 
              label: 'Storingen totaal',
              toelichting: 'storingen',
              filters: {
                types: ['INCIDENT'],
                category: ['TO']
              },
              value: keys.telling,
              _showDetails: false,
              result: this.storingen
            },
            { 
              label: 'Responsetijden totaal',
              toelichting: 'reactietijd',
              filters: {
                types: ['INCIDENT'],
                category: []
              },
              value: keys.reactietijd,
              _showDetails: false,
              result: this.responsetijden
            },
            { 
              label: 'Responsetijden totaal',
              toelichting: 'reactietijd',
              filters: {
                types: ['INCIDENT'],
                category: ['TO']
              },
              value: keys.reactietijd,
               _showDetails: false,
              result: this.responsetijden
            },
            { 
              label: 'Stilstandtijd totaal',
              toelichting: 'stilstand',
              filters: {
                types: ['MAINTENANCE', 'INCIDENT', 'REPAIR', 'ASSISTANCE INSPECTION', 'CHECK'],
                category: []
              },
              value: keys.reactietijd,
              _showDetails: false,
              result: this.stilstandtijd
            },
            { 
              label: 'Stilstandtijd totaal',
              toelichting: 'stilstand',
              filters: {
                types: ['MAINTENANCE', 'INCIDENT', 'REPAIR', 'ASSISTANCE INSPECTION', 'CHECK'],
                category: ['TO']
              },
              value: keys.reactietijd,
              _showDetails: false,
              result: this.stilstandtijd
            },
            { 
              label: 'Keuringen',
              filters: {
                types: ['MAINTEANCE'],
                category: []
              },
              value: keys.telling,
              _showDetails: false,
            },
            { 
              label: 'Conditie meting',
              filters: {
                types: ['MAINTEANCE'],
                category: []
              },
              value: keys.telling,
              _showDetails: false,
            },
            { 
              label: 'Preventief onderhoud aantal',
               filters: {
                types: ['MAINTENANCE'],
                category: []
              },
              value: keys.telling,
              _showDetails: false,
              result: this.onderhoudAantal
            },
            { 
              label: 'Preventief onderhoud duur',
               filters: {
                types: ['MAINTENANCE'],
                category: []
              },
              value: keys.stilstandtijd,
              _showDetails: false,
              result: this.onderhoudDuur
            },
            { 
              label: 'Prijs',
              onderhoudscategorie: 'B',
              filters: {
                types: ['MAINTEANCE'],
                category: []
              },
              
              value: keys.telling,
              _showDetails: false,
            },
            { 
              label: 'Prestatie administratief',
              onderhoudscategorie: 'B',
              filters: {
                types: ['MAINTEANCE'],
                category: []
              },
              value: keys.telling,
              _showDetails: false,
            },
          ],
        }
    },
    computed: {
      service() {
        if (this.status == undefined) return [];
        return this.status.service.filter(s => (s.p || this.config.filter.prestatie == false));
      },
      unitCount() {
        return this.units.filter((u) => u.oh == this.config.filter.onderhoudscategorie).length;
      },
      kpiService() {
        var quarters = this.quarters;
        return this.report.map((kpi) => {
          var quarterSet = quarters.reduce((a, b, index) => {
            a[`kw${index}`] = kpi.result != undefined ?  kpi.result(b.result,kpi.filters) : { score: 1, aantal: 0, percentage: 0 };
            return a;
          }, {});
          return {
            ...kpi,
            gemiddelde: kpi.result != undefined ? kpi.result(this.service,kpi.filters) : { score: 1,aantal: 0, percentage: 0 }, 
            quarters: quarterSet
          }})},
      kpiInstellingen() {
        // geen instellingen gevonden voor onderhoudscategorie dan default naar B
        if (this.config.instellingen[this.config.filter.onderhoudscategorie] == undefined) return this.config.instellingen['B'];
        return this.config.instellingen[this.config.filter.onderhoudscategorie];
      },
      quarters() {
        var quarters = [];
        if (this.status == undefined) return quarters;
        var range = this.status.kwartalen;
        var start = `${range.start}`; // format is yyq
        var eind = `${range.eind}`; // format is yyq
        var aantal_kwartalen = (parseInt(eind.substring(0, 2)) - parseInt(start.substring(0, 2))) *
                4 +
            parseInt(eind.substring(2, 3)) -
            parseInt(start.substring(2, 3)) +
            1;
        var startdate = new Date(
          parseInt(start.substring(0, 2)) + 2000,
          (parseInt(start.substring(2, 3)) - 1) * 3,
          1
        ); 
        for (let i = 0; i < aantal_kwartalen; i++) {
          let q =  startdate.getMonth() / 3 + 1;
          quarters.push({
            key: `kw${i}`,
            quarter: q,
            index: i,
            label: `Q${q} ${startdate.getFullYear()}`,
            year: startdate.getFullYear(),
            result: this.service.filter((s) => moment(s.a).toDate().getFullYear() == startdate.getFullYear() && moment(s.a).quarter() == q)
          });
          startdate.setMonth(startdate.getMonth() + 3);
        }
        return quarters;
      },
    },
    watch: {},
    mounted () {
        
    },
    methods: {
      showRowDetails(row) {
        row._showDetails = !row._showDetails;
        console.log(row);
      },
      serviceSet(service,filters) {
        return service.filter((t) => filters.types.includes(t.t) && ( filters.category.includes(t.c) ||  filters.category.length == 0));
      },
      replace(str,rep) {
        // string format replace
        if (rep == undefined) return str;
        return str.replace("{0}",rep);
      },
      getBeurtenKeo(aantalstopplaatsen) {
            let beurten = 0;
            if (this.kpiInstellingen == null) return beurten;
            // bepaal het aantal beurten, max stopplaatsen is een ordered list
            // dus als aantalstopplaatsen groter is dan de stopplaatsen van de eerste
            // dan is het aantal beurten van de eerste
            this.kpiInstellingen.keo.onderhoud.forEach((onderhoud) => {
                if (aantalstopplaatsen >= onderhoud.stopplaatsen) {
                    beurten = onderhoud.beurten;
                    return;
                }
            });
            return beurten;
        },
      beschikbaarheid(service,filters) {
        var perUnit = this.getPerUnitSum(this.serviceSet(service,filters),keys.stilstandtijd);
        var meerStilstand = Object.keys(perUnit).filter((u) => (perUnit[u]/60) >= this.kpiInstellingen.beschikbaarheid);
        return {
          units:  meerStilstand,
          percentage: (((this.unitCount - meerStilstand.length) / this.unitCount) * 100).toFixed(0),
          aantal: (meerStilstand.length),
          kpi: this.kpiScore(((this.unitCount - meerStilstand.length) / this.unitCount) * 100)
        }
      },
      
      storingen(service,filters) {
        var perUnit = this.getPerUnitCountValues(this.serviceSet(service,filters));
        // tel alleen units met maximaal 4 storingen
        var veelStoorders = Object.keys(perUnit).filter((u) => perUnit[u] >= this.kpiInstellingen.storingen);
        return {
          units: veelStoorders,
          percentage: (((this.unitCount - veelStoorders.length) / this.unitCount) * 100).toFixed(0),
          aantal: veelStoorders.length,
          kpi: this.kpiScore(((this.unitCount -veelStoorders.length) / this.unitCount) * 100)
        }
      },
      responsetijden(service,filters) {
        var perUnit = this.getPerUnitValues(this.serviceSet(service,filters),keys.reactietijd);
        // tel alleen units waar de maximale responsetijd niet wordt overschreden
        var responsetijden = Object.keys(perUnit).filter((u) => (Math.max(...perUnit[u])/60) >= this.kpiInstellingen.reactietijd );
        return {
          units: responsetijden,
          percentage: (((this.unitCount - responsetijden.length) / this.unitCount) * 100).toFixed(0),
          aantal: responsetijden.length,
          kpi: this.kpiScore(((this.unitCount - responsetijden.length) / this.unitCount) * 100)
        }
      },
      stilstandtijd(service, filters) {
        var perUnit = this.getPerUnitValues(this.serviceSet(service, filters), keys.stilstandtijd);
        // tel alleen units waar de maximale stilstandtijd niet wordt overschreden
        var stilstandtijd = Object.keys(perUnit).filter((u) => (Math.max(...perUnit[u])/60) >= this.kpiInstellingen.stilstand);
        return {
          units: stilstandtijd,
          percentage: (((this.unitCount - stilstandtijd.length) / this.unitCount) * 100).toFixed(0),
          aantal: stilstandtijd.length,
          kpi: this.kpiScore(((this.unitCount - stilstandtijd.length) / this.unitCount) * 100)
        }
      },
      onderhoudDuur(service, filters) {
        var perUnit = this.getPerUnitValues(this.serviceSet(service, filters), keys.stilstandtijd);
        // unit waarbij 1 onderhoudsbeurt onder de minimale duur valt
        var onderhoudDuur = Object.keys(perUnit).filter((u) => (Math.min(...perUnit[u])) <= this.kpiInstellingen.keo.minimale_duur );
        return {
          units: onderhoudDuur.map((u) => { return { unit: u, score: (Math.min(...perUnit[u])/60).toFixed(0) }}),
          percentage: (((this.unitCount - onderhoudDuur.length) / this.unitCount) * 100).toFixed(0),
          aantal: onderhoudDuur.length,
          kpi: this.kpiScore(((this.unitCount - onderhoudDuur.length) / this.unitCount) * 100)
        }
      },
      onderhoudAantal(service,filters) {
        var perUnit = this.getPerUnitCountValues(this.serviceSet(service, filters));
        var units = this.units.map((u) => { return { unit: u.id, stopplaatsen: u.config.ast,advies: this.getBeurtenKeo(u.config.ast), aantal: perUnit[u.id] }});
        
        var teWeinigOnderhoud = units.filter((u) => u.aantal < u.advies);
        console.log(teWeinigOnderhoud.length);
        return {
          units: units,
          percentage: (((this.unitCount - teWeinigOnderhoud.length) / this.unitCount) * 100).toFixed(0),
          aantal: teWeinigOnderhoud.length,
          kpi: this.kpiScore(((this.unitCount - teWeinigOnderhoud.length) / this.unitCount) * 100)
        }
      },
      kpiScore(percentage) {
        if (percentage >= this.kpiInstellingen.percentages[0]) return 3;
        if (percentage >= this.kpiInstellingen.percentages[1]) return 2;
        return 1;
      },
      getPerUnitValues(set,value) {
        return set.reduce((a, b) => {
          a[b.u.id] = (a[b.u.id] || []).concat(b[value]);
          return a;
        }, {});
      },
      getPerUnitCountValues(set,value) {
        var perUnit = this.getPerUnitValues(set,value);
        return Object.keys(perUnit).reduce((a, b) => {
          a[b] = perUnit[b].length;
          return a;
        }, {});
      },
      getPerUnitSum(set,value) {
        return set.reduce((a, b) => {
          a[b.u.id] = (a[b.u.id] || 0) + b[value];
          return a;
        }, {});
      },
      css(value,key,item) {
          //var score = item.result(item.value,item.filters).kpi; 
          if (item.result == undefined) return [];
          // console.log(key);
          var score = value;
          return [this.bgs[score-1],'lead','text-center','middle'];
      },
    },
}
</script>